import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { MatGridListModule } from '@angular/material/grid-list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';

import { MatButtonToggleModule } from '@angular/material/button-toggle'
;
import { MatDatepickerModule } from '@angular/material/datepicker';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';


import { MatDividerModule } from '@angular/material/divider';

import { MatNativeDateModule } from '@angular/material/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    imports: [
      MatGridListModule,
      MatToolbarModule,
      MatSidenavModule,
      MatTableModule,
      MatPaginatorModule,
      MatRadioModule,
      MatButtonModule,
      MatButtonToggleModule,
      MatInputModule,
      MatSelectModule,
      MatAutocompleteModule,
      MatCheckboxModule,
      MatRadioModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatSlideToggleModule,
      MatListModule,
      MatExpansionModule,
      MatIconModule,
      MatMenuModule,
      MatDialogModule,
      MatBottomSheetModule,
      MatSnackBarModule,
      MatTooltipModule,
      MatChipsModule,
      MatDividerModule,
      MatProgressSpinnerModule,
      MatProgressBarModule
    ],
    exports: [
        MatGridListModule,
        MatToolbarModule,
        MatSidenavModule,
        MatTableModule,
        MatPaginatorModule,
        MatRadioModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatInputModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSlideToggleModule,
        MatListModule,
        MatExpansionModule,
        MatIconModule,
        MatMenuModule,
        MatDialogModule,
        MatBottomSheetModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatChipsModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatStepperModule,
        MatFormFieldModule,
      ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
  })
  export class AppMaterialComponentsModule { }